import type { EmailPreferences, RawEmailSettings } from "@/types";

export function mapToEmailSettings(rawSettings: RawEmailSettings): EmailPreferences {
  return {
    companyLogo: rawSettings.company_logo || "",
    companyWebsite: rawSettings.company_website || "",
    paymentFqdn: rawSettings.payment_fqdn || "",
    paymentFqdnStatus: rawSettings.payment_fqdn_status || "",
    mailingAddress: rawSettings.mailing_address || "",
    DkimFromName: rawSettings.dkim_from_name || "",
    DkimEmailAddress: rawSettings.dkim_email_address || "",
    mailServer: rawSettings.mail_server as "default" | "smtp" || "default",
    smtpSettings: {
      fromName: rawSettings.smtp_settings?.from_name || "",
      emailAddress: rawSettings.smtp_settings?.email_address || "",
      smtpServer: rawSettings.smtp_settings?.smtp_server || "",
      username: rawSettings.smtp_settings?.username || "",
      password: rawSettings.smtp_settings?.password || "",
      encryptionType: rawSettings.smtp_settings?.encryption_type || "SSL",
      portNumber: rawSettings.smtp_settings?.port_number ? rawSettings.smtp_settings.port_number.toString() : ""
    },
    defaultSettings: {
      data: rawSettings.default_settings?.data || [],
      dkimEmailDomain: rawSettings.default_settings?.dkim_email_domain || "",
      dkimEmailPrefix: rawSettings.default_settings?.dkim_email_prefix || "",
      dkimFromName: rawSettings.default_settings?.dkim_from_name || ""
    },
    isConfigured: rawSettings.is_configured || false
  };
}
